// export const receiptTypeEnum: { [key: string]: string } = {
//   Quick: '0464fc34-11f9-490f-b469-7f5d4d7150f1',
//   Refund: 'b600351c-8d3c-43df-83c4-9120a79c74aa',
//   Standard: '52ea7dc3-92b7-406d-9f79-f12e0fb8fdb2',
//   PrePayment: 'e232d787-c1d1-4d97-be39-ff52f9010683'
// };

export const receiptTypeEnum: { [key: string]: string } = {
  Quick: '0464fc34-11f9-490f-b469-7f5d4d7150f1',
  Refund: 'b600351c-8d3c-43df-83c4-9120a79c74aa',
  Standard: '52ea7dc3-92b7-406d-9f79-f12e0fb8fdb2',
  // Offset: "b2e01e84-98f9-4d51-9f7f-beec65353953",
  PreReceipt: 'e232d787-c1d1-4d97-be39-ff52f9010683',
  ApplyPreReceipt: '45de9a40-acc4-4088-ab2f-3b07b98d3927',
  ApplyCreditMemo: 'b2e01e84-98f9-4d51-9f7f-beec65353953',
  PreReceiptRefund: '5c18c696-2ef8-43b7-97d9-ab5654f2c0b0'
};
